import { useRef, useState, useEffect } from "react";
import Quill, { QuillOptions } from "quill";

const defaultModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["link"],
    [{ color: [] }, { background: [] }],
    ["clean"],
  ],
};

const defaultFormats = [
  "bold",
  "italic",
  "underline",
  "strike",
  "align",
  "list",
  "indent",
  "size",
  "header",
  "link",
  "color",
  "background",
];

// Created once, so the reference is stable across renders
const defaultOptions: QuillOptions = {
  theme: "snow",
  modules: defaultModules,
  formats: defaultFormats,
};

export const useQuill = (options: QuillOptions = defaultOptions) => {
  const quillRef = useRef<HTMLDivElement | null>(null);
  const [quill, setQuill] = useState<Quill | null>(null);

  useEffect(() => {
    if (quillRef.current && !quill) {
      const quillInstance = new Quill(quillRef.current, {
        theme: "snow",
        ...options,
        modules: { ...defaultModules, ...options.modules },
        formats: options.formats || defaultFormats,
      });

      setQuill(quillInstance);
    }
  }, [quill, options]);

  return { quill, quillRef };
};
